//#region src/campus_card_account_type.ts
var CampusCardAccountType = /* @__PURE__ */ function(CampusCardAccountType) {
	CampusCardAccountType["StoredValue"] = "stored-value";
	CampusCardAccountType["MealPlan"] = "meal-plan";
	CampusCardAccountType["CashEquivalency"] = "cash-equivalency";
	return CampusCardAccountType;
}(CampusCardAccountType || {});
//#endregion
export { CampusCardAccountType };

//# sourceMappingURL=campus_card_account_type.js.map